<template>
  <v-table>
    <thead>
      <tr>
        <th class="text-left">Module</th>
        <th class="text-left">Show</th>
        <th class="text-left">Create</th>
        <th class="text-left">Edit</th>
        <th class="text-left">Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="module in modules" :key="module.id">
        <td>
          <span class="d-flex align-center ga-2">
            <img
              :src="module.image"
              width="32"
              height="32"
              :alt="module.name"
            />
            {{ module.name }}
          </span>
        </td>
        <td>
          <v-checkbox
            color="#237276"
            :model-value="hasPermission(module, 'show')"
            readonly
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            :model-value="hasPermission(module, 'create')"
            color="#237276"
            readonly
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            :model-value="hasPermission(module, 'update')"
            color="#237276"
            readonly
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            :model-value="hasPermission(module, 'delete')"
            color="#237276"
            readonly
          ></v-checkbox>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
export default {
  name: "RolePermission",
  props: {
    role_permissions: {
      type: Array,
      required: true,
      default: () => [],
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modules() {
      return Object.entries(this.role_permissions).map(([name, value]) => ({
        name,
        image: value.image,
        actions: value.actions.map((a) => a.name), // ['read', 'create']
      }));
    },
  },
  methods: {
    hasPermission(module, type) {
      const map = {
        show: "read",
        create: "create",
        update: "update",
        delete: "delete",
      };
      return module.actions.includes(map[type]);
    },
  },
};
</script>
